import { DefaultError, useQuery } from '@tanstack/react-query';
import { ISettlementInfoTime } from 'services/music-product-digital/types/query';
import { apiClient } from 'utils';
import { useResponseHandler } from 'utils/service/responseHandler';
import {
  IChannelSettlementInfoForm,
  IChannelVideoContractsTime,
} from './types/query';

export const useGetChannelContractFuture = (ChannelId: string) => {
  const { responseHandler } = useResponseHandler();
  return useQuery<
    ISettlementInfoTime<IChannelSettlementInfoForm>,
    DefaultError
  >({
    queryKey: ['channel-contract-future', ChannelId],
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: `Channel/Contract/Future`,
        params: { ChannelId },
      });

      return responseHandler(response, {
        groupName: `useGetChannelContractFuture - ${ChannelId}`,
      });
    },
  });
};

export const useGetChannelContractHistory = (ChannelId: string) => {
  const { responseHandler } = useResponseHandler();
  return useQuery<
    ISettlementInfoTime<IChannelSettlementInfoForm>,
    DefaultError
  >({
    queryKey: ['channel-contract-history', ChannelId],
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: `Channel/Contract/History`,
        params: { ChannelId },
      });

      return responseHandler(response, {
        groupName: `useGetChannelContractHistory - ${ChannelId}`,
      });
    },
  });
};

export const useGetChannelVideoContractFuture = (VideoId: string) => {
  const { responseHandler } = useResponseHandler();
  return useQuery<IChannelVideoContractsTime, DefaultError>({
    queryKey: ['channel-contract-future', VideoId],
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: `Channel/Videos/Contract/Future`,
        params: { VideoId },
      });

      return responseHandler(response, {
        groupName: `useGetChannelVideoContractFuture - ${VideoId}`,
      });
    },
  });
};

export const useGetChannelVideoContractHistory = (VideoId: string) => {
  const { responseHandler } = useResponseHandler();
  return useQuery<IChannelVideoContractsTime, DefaultError>({
    queryKey: ['channel-contract-history', VideoId],
    async queryFn() {
      const response = await apiClient({
        method: 'GET',
        url: `Channel/Videos/Contract/History`,
        params: { VideoId },
      });

      return responseHandler(response, {
        groupName: `useGetChannelVideoContractHistory - ${VideoId}`,
      });
    },
  });
};
